import { render, staticRenderFns } from "./CourseCategorysList.vue?vue&type=template&id=42ca94bb&scoped=true&"
import script from "./CourseCategorysList.vue?vue&type=script&lang=js&"
export * from "./CourseCategorysList.vue?vue&type=script&lang=js&"
import style0 from "./CourseCategorysList.vue?vue&type=style&index=0&id=42ca94bb&lang=scss&scoped=true&"
import style1 from "./CourseCategorysList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca94bb",
  null
  
)

export default component.exports